export const TwitterIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M18.3263 1.90356H21.6998L14.3297 10.3271L23 21.7895H16.2112L10.894 14.8376L4.80995 21.7895H1.43443L9.31743 12.7797L1 1.90356H7.96111L12.7674 8.2579L18.3263 1.90356ZM17.1423 19.7703H19.0116L6.94539 3.8167H4.93946L17.1423 19.7703Z"
            fill="white"
        />
    </svg>
);
